import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HeroBasicActionsEndDirective,
  HeroBasicActionsStartDirective,
  HeroBasicComponent,
} from './hero-basic.component';

@NgModule({
  declarations: [
    HeroBasicComponent,
    HeroBasicActionsStartDirective,
    HeroBasicActionsEndDirective,
  ],
  imports: [CommonModule],
  exports: [
    HeroBasicComponent,
    HeroBasicActionsStartDirective,
    HeroBasicActionsEndDirective,
  ],
})
export class HeroBasicModule {}
